import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';

import Routes from './routes';

export function RootRoutes () {
  return (
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store = { store } >
    <RootRoutes />
  </Provider>
);